import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Pasaré hambre?',
  a: 'No, el protocolo incluye proteínas y fibras saciantes.'
}, {
  q: '¿Tengo que comprar suplementos caros?',
  a: 'No, todo se encuentra en un supermercado normal.'
}, {
  q: '¿Puedo hacerlo si trabajo?',
  a: 'Está diseñado para ejecutarse el fin de semana, pero es adaptable.'
}, {
  q: '¿Es seguro?',
  a: 'Sí, se basa en comida real y principios de nutrición funcional.'
}];
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-sage/20 last:border-0" data-id="element-31">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-32">
        <span className="text-lg md:text-xl font-playfair font-semibold text-charcoal group-hover:text-terracotta transition-colors" data-id="element-33">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-terracotta transition-transform duration-300 flex-shrink-0 ml-4 ${isOpen ? 'rotate-180' : ''}`} data-id="element-34" />
      </button>
      <AnimatePresence data-id="element-35">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-36">
            <p className="pb-6 text-warmgray leading-relaxed" data-id="element-37">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  return <section className="py-16 md:py-24 px-6 bg-white" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <FadeIn data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-charcoal" data-id="element-41">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-42">
          <div className="bg-cream rounded-3xl p-6 md:p-10 shadow-sm" data-id="element-43">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-44" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}